import React, { useState, useEffect } from 'react';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_orion";
import NoData from "../../../Dashboard/Driveanalysis/NoData";
import ChartLoader from "../../../Dashboard/Driveanalysis/ChartLoader";
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";
import moment from "moment";
import { Line } from "react-chartjs-2";
import * as $ from "jquery";
import 'chartjs-plugin-datalabels';

let arrayimb = [];
let arrayimb_month = [];

export default function SecondPageFirstGraph_Orion(props) {

  let temp = [];
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [LineContainerBody, setCssLineCont] = useState({ height: "375px" });

  const [faultSelected, setFaultSelected] = useState("day");
  const [falutTriggerParams, setFaultTriggerParams] = useState([]);
  const [falutTrigger, setFaultTrigger] = useState({
    labels: [],
    datasets: [],
    options: {
      plugins: {
        datalabels: {
          display: false,
        },
        tooltip: {
          enabled: true // Disable tooltip
        }
      },
      scales: {
        y: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: "Fault count",
          },
        },
        x: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: "Month",
          },
        },
      },
      maintainAspectRatio: false,
    },
  });

  function datesArray(start, end) {
    let result = [],
      current = new Date(start);
    while (current <= end)
      result.push(current) &&
        (current = new Date(current)) &&
        current.setDate(current.getDate() + 1);

    if (current.getDate() <= end.getDate())
      result.push(current) &&
        (current = new Date(current)) &&
        current.setDate(current.getDate() + 1);

    for (let i = 0; i < result.length; i++) {
      temp.push(result[i].toISOString().slice(0, 10));
    }
    return temp;
  }

  const getMonths = (fromDate, toDate) => {
    const fromYear = fromDate.getFullYear();
    let fromMonth = fromDate.getMonth();
    const toYear = toDate.getFullYear();
    let toMonth = toDate.getMonth();
    const months = [];

    for (let year = fromYear; year <= toYear; year++) {
      let monthNum = year === fromYear ? fromMonth : 0;
      const monthLimit = year === toYear ? toMonth : 11;

      for (; monthNum <= monthLimit; monthNum++) {
        let month = monthNum + 1;
        month = month < 10 ? "0" + month : "" + month;
        year = year.toString();
        let yeamon = year.concat(month);
        months.push(yeamon);
      }
    }
    return months;
  };

  function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString("en-US", { month: "short" });
  }

  function responceDataDate(dataDateimb) {
    let dataDate = [];
    if (dataDateimb.length > 0) {
      for (let i = 0; i < dataDateimb.length; i++) {
        dataDate.push({
          key: {
            ECU: dataDateimb[i].key.ECU,
            eventdate: dataDateimb[i].key.eventdate,
          },
          occ: { value: dataDateimb[i].occ.value },
        });
      }

      for (let i = 0; i < arrayimb.length; i++) {
        dataDate.push({
          key: {
            ECU: arrayimb[i].key.ECU,
            eventdate: arrayimb[i].key.eventdate,
          },
          occ: { value: arrayimb[i].occ.value },
        });
      }

      let defaultArr = [];
      let colorArr = [
        "#3588A6",
        "#71BDDD",
        "#F39530",
        "#00866E",
        "#002942",
        "#F9F871",
        "#9E480E",
        "#636363",
        "#A5A5A5",
        // "#255E91",
        // "#fce4d6",
        //"#b59888",
        "#f8cbad"
      ];
      for (let m = 0; m < falutTriggerParams.length; m++) {
        defaultArr.push({
          label: falutTriggerParams[m],
          data: [],
          fill: false,
          borderColor: colorArr[m],
        });
      }
      const dateArr = datesArray(
        new Date(props.gloablfilter.startDate),
        new Date(props.gloablfilter.endDate)
      );
      for (let q = 0; q < dateArr.length; q++) {
        dataDate.forEach((obj1) => {
          if (dateArr[q] === obj1.key.eventdate) {
            for (let t = 0; t < defaultArr.length; t++) {
              if (defaultArr[t].label === obj1.key.ECU) {
                defaultArr[t].data.push(obj1.occ.value);
              }
            }
          }
        });

        let count = 0;
        for (let pt = 0; pt < defaultArr.length; pt++) {
          if (defaultArr[pt].data.length > count) {
            count = defaultArr[pt].data.length;
          }
        }

        for (let xt = 0; xt < defaultArr.length; xt++) {
          if (defaultArr[xt].data.length !== count) {
            defaultArr[xt].data.push(0);
          }
        }
      }
      let totObj = {
        label: "Total",
        data: [],
        fill: false,
        borderColor: "#72d817",
      };
      for (let q = 0; q < defaultArr[0].data.length; q++) {
        let sum = 0;
        for (let index = 0; index < defaultArr.length; index++) {
          if (defaultArr[index].label !== "IMB")
            sum = sum + defaultArr[index].data[q];
        }
        totObj.data.push(sum);
      }
      defaultArr.push(totObj);

      let monthArrayD = [];
      dataDate.map(({ key, i }) => {
        monthArrayD.indexOf(key.eventdate) === -1 &&
          monthArrayD.push(key.eventdate);
      });

      let aa = monthArrayD.sort((a, b) => new Date(a) - new Date(b));
      const data = {
        labels: monthArrayD,
        datasets: defaultArr,
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Day",
              },
            },
          },
          maintainAspectRatio: false,
        },
      };
      setFaultTrigger(data);
      arrayimb = [];
    } else {
      setFaultTrigger({
        labels: [],
        datasets: [],
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      });
    }
  }

  const changeFaultTrigger = (selectOp) => {
    setFaultSelected(selectOp);
    if (selectOp === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "orion_fault_analysis_second_page/chart_fault_triggred_monthwise",
          body: {
            ECUparams: falutTriggerParams,
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: props.gloablfilter.vin_num,
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
          },
        },
        responceData
      );
    } else {
      fetchData(
        {
          url:
            API_URL_MAIN + "orion_fault_analysis_second_page/chart_fault_triggred_daywise",
          body: {
            ECUparams: falutTriggerParams,
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: props.gloablfilter.vin_num,
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
          },
        },
        responceDataDate
      );
    }
  };

  const responceData = (dataDateimb) => {
    if (dataDateimb.length > 0) {
      let dataRes = dataDateimb;
      for (let i = 0; i < arrayimb_month.length; i++) {
        dataRes.push({
          key: {
            ECU: arrayimb_month[i].key.ECU,
            monthId: arrayimb_month[i].key.eventdate,
          },
          occ: { value: arrayimb_month[i].occ.value },
        });
      }
      dataRes.sort(function (a, b) {
        return a.key.monthId - b.key.monthId;
      });


      let defaultArr = [];
      let colorArr = [
        "#3588A6",
        "#71BDDD",
        "#F39530",
        "#00866E",
        "#002942",
        "#F9F871",
        "#9E480E",
        "#636363",
        "#A5A5A5",
        // "#255E91",
        // "#fce4d6",
        //"#b59888",
        "#f8cbad"
      ];
      // #3588A6#00A4B3#13C0AF#62D89C#ABEB83#F9F871
      for (let m = 0; m < falutTriggerParams.length; m++) {
        defaultArr.push({
          label: falutTriggerParams[m],
          data: [],
          fill: false,
          borderColor: colorArr[m],
        });
      }

      let st = moment(new Date(props.gloablfilter.startDate)).format(
        "YYYY-MM-DD"
      );
      let ed = moment(new Date(props.gloablfilter.endDate)).format(
        "YYYY-MM-DD"
      );
      const dateArr = getMonths(new Date(st), new Date(ed));
      for (let q = 0; q < dateArr.length; q++) {
        dataRes.forEach((obj1) => {
          if (dateArr[q] === obj1.key.monthId) {
            for (let t = 0; t < defaultArr.length; t++) {
              if (defaultArr[t].label === obj1.key.ECU) {
                defaultArr[t].data.push(obj1.occ.value);
              }
            }
          }
        });

        let count = 0;
        for (let pt = 0; pt < defaultArr.length; pt++) {
          if (defaultArr[pt].data.length > count) {
            count = defaultArr[pt].data.length;
          }
        }

        for (let xt = 0; xt < defaultArr.length; xt++) {
          if (defaultArr[xt].data.length !== count) {
            defaultArr[xt].data.push(0);
          }
        }
      }

      let monthArray = [];
      dataRes.map(({ key, i }) => {
        let year = key.monthId.substring(0, 4);
        let month = key.monthId.substring(4);
        let monthYear = getMonthName(month) + "-" + year;
        monthArray.indexOf(monthYear) === -1 && monthArray.push(monthYear);
      });

      let totObj = {
        label: "Total",
        data: [],
        fill: false,
        borderColor: "#72d817",
      };
      for (let q = 0; q < defaultArr[0].data.length; q++) {
        let sum = 0;
        for (let index = 0; index < defaultArr.length; index++) {
          if (defaultArr[index].label !== "IMB")
            sum = sum + defaultArr[index].data[q];
        }
        totObj.data.push(sum);
      }
      defaultArr.push(totObj);

      const data = {
        labels: monthArray,
        datasets: defaultArr,
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      };
      setFaultTrigger(data);
      arrayimb_month = [];
    } else {
      setFaultTrigger({
        labels: [],
        datasets: [],
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      });
    }
  };

  function responceDataParam(dataParam) {
    if (dataParam.length > 0) {
      let paramArray = [
        { key: { ECU: "BCS-1" }, doc_count: 59 },
        { key: { ECU: "BCS-2" }, doc_count: 47 },
        {
          key: {
            ECU: "BMS",
          },
          doc_count: 1041,
        },
        {
          key: {
            ECU: "HVAC",
          },
          doc_count: 1255,
        },
        {
          key: {
            ECU: "VCU",
          },
          doc_count: 3460,
        },
        {
          key: {
            ECU: "Aux-1",
          },
          doc_count: 3460,
        },
        {
          key: {
            ECU: "Aux-2",
          },
          doc_count: 3460,
        },
        {
          key: {
            ECU: "MCU",
          },
          doc_count: 3460,
        },
        {
          key: {
            ECU: "IMB",
          },
          doc_count: 3460,
        },
        {
          key: {
            ECU: "DC-DC",
          },
          doc_count: 340,
        },
      ];

      let paramArray_data = [];
      paramArray.forEach((obj1, index) => {
        paramArray_data.push(obj1.key.ECU);
      });
      setFaultTriggerParams(paramArray_data);
    } else {
      setFaultTriggerParams([]);
    }
  }
  function responceDataParamImb(dataimb) {
    const data = dataimb;
    for (let i = 0; i < data.length; i++) {
      arrayimb.push({
        key: { ECU: "IMB", eventdate: data[i].key.eventdate },
        occ: { value: data[i].occurance.value },
      });
    }
  }

  const responceDataParamImb_Month = (data) => {
    // code added only push "IBM" if not exits
    const index = arrayimb_month.findIndex(object => object.key.ECU === "IMB");
    if (index === -1) {
      // code added only push "IBM" if not exits
      for (let i = 0; i < data.length; i++) {
        arrayimb_month.push({
          key: { ECU: "IMB", eventdate: data[i].key.monthId },
          occ: { value: data[i].occ.value },
        });
      }
    }
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "orion_fault_analysis_second_page/chart_fault_triggred_unit",
        body: {
          startDate: props.gloablfilter.startDate,
          endDate: props.gloablfilter.endDate,
          vin_num: props.gloablfilter.vin_num,
          CITY: props.gloablfilter.CITY,
          DEPO: props.gloablfilter.DEPO,
        },
      },
      responceDataParam
    );

    fetchData(
      {
        url:
          API_URL_MAIN +
          "orion_fault_analysis_second_page/chart_imbalanace_duration_occ_monthwise",
        body: {
          startDate: props.gloablfilter.startDate,
          endDate: props.gloablfilter.endDate,
          vin_num: props.gloablfilter.vin_num,
          CITY: props.gloablfilter.CITY,
          DEPO: props.gloablfilter.DEPO,
        },
      },
      responceDataParamImb_Month
    );

    fetchData(
      {
        url:
          API_URL_MAIN +
          "orion_fault_analysis_second_page/chart_imbalanace_duration_occ_daywise",
        body: {
          startDate: props.gloablfilter.startDate,
          endDate: props.gloablfilter.endDate,
          vin_num: props.gloablfilter.vin_num,
          CITY: props.gloablfilter.CITY,
          DEPO: props.gloablfilter.DEPO,
        },
      },
      responceDataParamImb
    );
  }, [props]);

  useEffect(() => {
    $("canvas").css("display", "");
    if (faultSelected === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "orion_fault_analysis_second_page/chart_fault_triggred_monthwise",
          body: {
            ECUparams: falutTriggerParams,
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: props.gloablfilter.vin_num,
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
          },
        },
        responceData
      );
    } else {
      fetchData(
        {
          url:
            API_URL_MAIN + "orion_fault_analysis_second_page/chart_fault_triggred_daywise",
          body: {
            ECUparams: falutTriggerParams,
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: props.gloablfilter.vin_num,
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
          },
        },
        responceDataDate
      );
    }
  }, [falutTriggerParams]);

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mb-3">
      <div className="v-title chartbox3">
        <div className="row mb-1">
          <div className="col-md-14 col-sm-14 col-lg-14 ">
            <div className="titlebg_bus_fault text-fit" id="sankalp">
              Faults Triggered
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6 col-sm-6 col-lg-8"></div>
            <div className="col-md-12 col-sm-6 col-lg-4">
              <select
                className="form-select form-select-sm"
                aria-label="Default select example"
                onChange={(event) => changeFaultTrigger(event.target.value)}
                value={faultSelected}
              >
                <option value="month">Month</option>
                <option value="day">Day</option>
              </select>
            </div>
          </div>
        </div>

        <div className="chartHGT">
          <div style={{}}>
            <WaterMark />
            <div style={LineContainerBody} className="LineContainerBody">
              {isLoading ? (
                <ChartLoader />
              ) : falutTrigger.datasets.length > 0 ? (
                <Line data={falutTrigger} options={falutTrigger.options} />
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
